var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 35C16.1667 35 12.8267 33.7294 9.98 31.1883C7.13333 28.6472 5.50111 25.4733 5.08333 21.6667H8.5C8.88889 24.5556 10.1739 26.9444 12.355 28.8333C14.5361 30.7222 17.0844 31.6667 20 31.6667C23.25 31.6667 26.0072 30.535 28.2717 28.2717C30.5361 26.0083 31.6678 23.2511 31.6667 20C31.6667 16.75 30.535 13.9933 28.2717 11.73C26.0083 9.46667 23.2511 8.33444 20 8.33333C18.0833 8.33333 16.2917 8.77778 14.625 9.66667C12.9583 10.5556 11.5556 11.7778 10.4167 13.3333H15V16.6667H5V6.66667H8.33333V10.5833C9.75 8.80556 11.4794 7.43056 13.5217 6.45833C15.5639 5.48611 17.7233 5 20 5C22.0833 5 24.035 5.39611 25.855 6.18833C27.675 6.98056 29.2583 8.04944 30.605 9.395C31.9517 10.7428 33.0211 12.3261 33.8133 14.145C34.6056 15.9639 35.0011 17.9156 35 20C35 22.0833 34.6044 24.035 33.8133 25.855C33.0222 27.675 31.9528 29.2583 30.605 30.605C29.2572 31.9517 27.6739 33.0211 25.855 33.8133C24.0361 34.6056 22.0844 35.0011 20 35ZM24.6667 27L18.3333 20.6667V11.6667H21.6667V19.3333L27 24.6667L24.6667 27Z",
    fill: "#0BB7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.d04aeff618577835d7ac26869a9fa3cc.svg";
export { ForwardRef as ReactComponent };